import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { NewMemberOfType } from 'types/order';

const useStyles = makeStyles((theme: any) => ({
  text: {
    color: theme.palette.text.secondary,
    overflowWrap: 'anywhere',
  },
}));

interface PartyCompaniesTextProps {
  members: NewMemberOfType[] | undefined;
}

const PartyCompaniesText: FC<PartyCompaniesTextProps> = ({ members }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const names = (members || []).map((member) => member.name).filter(Boolean);

  if (!names.length) return null;

  const companyList =
    names.length === 1
      ? names[0]
      : `${names.slice(0, -1).join(', ')} ${t('common:and')} ${names[names.length - 1]}`;

  return (
    <Typography variant="caption" component="span" className={classes.text}>
      {`${t('common:from')} ${companyList}`}
    </Typography>
  );
};

export default PartyCompaniesText;
